module.exports = __webpack_public_path__ + "static/lolth-DND3_FnP-9c5fccf19bd494c2b2cd3199667ec122.webp";